/* eslint-disable arrow-body-style */
// @flow
import React from 'react';
import { t } from 'javascripts/utils/withTranslation';
import type { BurgerProps } from '../types';
import Back from './Back';
import Headline from '../../../atoms/headline/react/Headline';

const BurgerContentLanguage = ({
  setStepKey,
  languages,
}: BurgerProps): React$MixedElement => {
  return (
    <div className="burger__content burger__content--sub">
      <div className="burger__inner">
        <Back setStepKey={setStepKey} />

        <div className="burger__headline">
          <Headline level={2} size={6} id="languages-headline">
            {t('Sprache wählen')}
          </Headline>
        </div>

        <nav aria-labelledby="#languages-headline" className="burger__nav">
          <ul className="burger__list">
            {languages?.map((lang, index) => (
              <li key={index} className="burger__list-item">
                <a href={lang.link} className="burger__link">
                  <span className="burger__link-text">{lang.text}</span>
                </a>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default BurgerContentLanguage;
